import { useState, useEffect, useReducer } from "react";
import openSocket from "../../services/socket-io";

import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex] = whatsApp;
			return [...state];
		} else {
			return [whatsApp, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
    let active = true;
    let pending = false;
    let reload = false;
    let retry;
    const fetchSession = async () => {
      if (!active) return;
      if (pending) { reload = true; return; }
      pending = true;
      clearTimeout(retry);
      try {
        const { data } = await api.get("/whatsapp/");
        if (active) dispatch({ type: "LOAD_WHATSAPPS", payload: data });
      } catch (error) {
        // Keep the last known accounts while connectivity/authentication recovers.
        if (active) retry = setTimeout(fetchSession, 15000);
      } finally {
        pending = false;
        if (active) setLoading(false);
        if (active && reload) { reload = false; fetchSession(); }
      }
    };
    const socket = openSocket();
    socket.on("connect", fetchSession);
    socket.on("whatsapp", data => {
      if (data.action === "update") dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      if (data.action === "delete") dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
    });
    socket.on("whatsappSession", data => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_SESSION", payload: data.session });
        fetchSession();
      }
    });
    const resume = () => { if (document.visibilityState === "visible") fetchSession(); };
    window.addEventListener("zapticket:token-updated", fetchSession);
    window.addEventListener("online", fetchSession);
    document.addEventListener("visibilitychange", resume);
    fetchSession();
    return () => {
      active = false;
      clearTimeout(retry);
      window.removeEventListener("zapticket:token-updated", fetchSession);
      window.removeEventListener("online", fetchSession);
      document.removeEventListener("visibilitychange", resume);
      socket.disconnect();
    };
  }, []);

  return { whatsApps, loading };
};
export default useWhatsApps;
